import { combineReducers } from '@ngrx/store';

import { siteReducer, type SiteState, WEBSITE_SITE_FEATURE_KEY } from './site/site.reducer';
import { pagesReducer, type PagesState, WEBSITE_PAGES_FEATURE_KEY } from './pages/pages.reducer';
import { contentReducer, type ContentState, WEBSITE_CONTENT_FEATURE_KEY } from './content/content.reducer';
import { settingsReducer, type SettingsState, WEBSITE_SETTINGS_FEATURE_KEY } from './settings/settings.reducer';
import {
    pageSettingsReducer,
    type PageSettingsState,
    WEBSITE_PAGE_SETTINGS_FEATURE_KEY,
} from './page-settings/page-settings.reducer';
import { domainsReducer, type DomainsState, WEBSITE_DOMAINS_FEATURE_KEY } from './domains/domains.reducer';
import {
    type CatalogState,
    productCatalogReducer,
    WEBSITE_CATALOG_FEATURE_KEY,
} from '@web/store/website/product-catalog/product-catalog.reducer';

export type WebsiteState = {
    [WEBSITE_SITE_FEATURE_KEY]: SiteState;
    [WEBSITE_PAGES_FEATURE_KEY]: PagesState;
    [WEBSITE_CONTENT_FEATURE_KEY]: ContentState;
    [WEBSITE_SETTINGS_FEATURE_KEY]: SettingsState;
    [WEBSITE_PAGE_SETTINGS_FEATURE_KEY]: PageSettingsState;
    [WEBSITE_DOMAINS_FEATURE_KEY]: DomainsState;
    [WEBSITE_CATALOG_FEATURE_KEY]: CatalogState;
};

export const WEBSITE_FEATURE_KEY = 'website';

export const websiteReducer = combineReducers<WebsiteState>({
    [WEBSITE_SITE_FEATURE_KEY]: siteReducer,
    [WEBSITE_PAGES_FEATURE_KEY]: pagesReducer,
    [WEBSITE_CONTENT_FEATURE_KEY]: contentReducer,
    [WEBSITE_SETTINGS_FEATURE_KEY]: settingsReducer,
    [WEBSITE_PAGE_SETTINGS_FEATURE_KEY]: pageSettingsReducer,
    [WEBSITE_DOMAINS_FEATURE_KEY]: domainsReducer,
    [WEBSITE_CATALOG_FEATURE_KEY]: productCatalogReducer,
});
